import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MailService } from 'src/app/_core/services/mail.service';
import { arrayEmpty } from 'src/app/utils/array.utils';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import {
    DocumentCodesListMode,
    GeneratedMailDocument,
    SharedMailComponent,
    SharedMailPublipostageCode
} from 'src/app/_shared/components/mail/shared-mail/shared-mail.component';

export interface MailParameters {
    label?: string;
    idsList: number[];
    publipostageCode: SharedMailPublipostageCode;
    documentCodesList?: number[] | string[];
    documentCodesListMode?: DocumentCodesListMode;
    viewId?: number;
    generatedDocumentsList?: GeneratedMailDocument[];
}

@Component({
    selector: 'app-shared-mail-container',
    templateUrl: './shared-mail-container.component.html',
    styleUrls: ['./shared-container-mail.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedMailContainerComponent extends BaseComponent implements OnInit {

    @Input() mailParameters: MailParameters[];

    @Output() closeContainer = new EventEmitter<void>();

    form: UntypedFormGroup;

    constructor(private readonly fb: UntypedFormBuilder,
                private readonly mailService: MailService,
                protected readonly cdr: ChangeDetectorRef) {
        super(cdr);
    }

    get loading$(): Observable<boolean> {
        return this.mailService.loading$;
    }

    get mailsList(): UntypedFormArray {
        return this.form.get(['mailsList']) as UntypedFormArray;
    }

    closeTab(index: number): void {
        this.mailsList.removeAt(index);
        const selectedTab = this.form.get('selectedTab');
        const countTabs = this.mailsList.controls.length;

        if (arrayEmpty(this.mailsList.controls)) {
            this.closeContainer.emit();
        } else if (selectedTab.value === countTabs) {
            selectedTab.patchValue(countTabs - 1);
        }

        this.cdr.markForCheck();
    }

    sendMail(index: number): void {
        const mail = this.mailsList.controls[index].get('mail').value;
        const {idsList, generatedDocumentsList} = this.getMailParameters(index);

        this.watch$ = this.mailService.sendPublipostageMail({mail, idsList, generatedDocumentsList}).pipe(
            tap(() => this.closeTab(index))
        );
    }

    getMailParameters(index: number): MailParameters {
        return this.mailsList.controls[index].get('parameters').value;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            selectedTab: [0],
            mailsList: this.fb.array([])
        });

        this.mailParameters.forEach(e => {
            this.mailsList.push(this.fb.group({
                mail: [null, [SharedMailComponent.Validator]],
                parameters: [e]
            }));
        });
    }
}
